<template>
  <div class="home">
    <!-- <div class="nav">
      <div style="flex: 3"></div>
      <div style="flex: 1">
        <span style="color: #fff" @click="logoutHandler">logout</span>
      </div>
    </div> -->
    <div
      class="webapp-container"
      :style="screenDimension"
      v-if="url.length !== 0"
    >
      <iframe
        id="webview"
        :src="url"
        allow="web-share;autoplay;fullscreen"
        frameborder="0"
        style="height:100%;width:100%;border: none"
      ></iframe>
    </div>
    <div class="loading-container">
      <loading
        :active.sync="isLoading"
        background-color="#000"
        :can-cancel="false"
        :is-full-page="false"
        color="#ee373b"
        style="z-index: 10"
      ></loading>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "Home",
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    url() {
      // the url
      if (this.$store.getters.url && this.$store.getters.url.length !== 0) {
        this.isLoading = false;
      } else {
        this.$router.push("/");
      }
      return this.$store.getters.url;
    },
    screenDimension() {
      return {
        "--width": window.innerWidth,
        "--height": window.innerHeight - 50,
      };
    },
  },
  methods: {
    logoutHandler() {
      this.$store.dispatch("logout");
    },
  },
  components: {
    Loading,
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.nav {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
  background-color: #ee373b;
}
.webapp-container {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
}
.loading-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-image: url("../assets/images/main.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: 10;
}
</style>
